import { render, staticRenderFns } from "./ReferenceTitle.vue?vue&type=template&id=0aa76c20&scoped=true&"
import script from "./ReferenceTitle.vue?vue&type=script&lang=js&"
export * from "./ReferenceTitle.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTitle.vue?vue&type=style&index=0&id=0aa76c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa76c20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
